import React, { useEffect, useState } from "react";

import GalleryScope from "../../theme/GalleryScope";
import BannerHome from "./components/BannerHome";
import IntroSection from "./components/IntroSection";
import AuctionAndExhibition from "./components/AuctionAndExhibition";
import { CurrentExhibitions } from "./components/ExhibitionSections";
import Publication from "./components/Publication";
import Video from "./components/Video";
import HowTosell from "./components/HowTosell";
import GalleriesSection from "./components/GalleriesSection";
import LiveStream from "./components/LiveStream";
import { fetchCurrentExhibitions } from "./homeData";

import ActivitySection from "./components/ActivitySection";

// Mobile-only tuning for the home card rails. Desktop remains unchanged.
import "./home-mobile.css";

function Home() {
  const [exhibitions, setExhibitions] = useState([]);

  useEffect(() => {
    let active = true;

    fetchCurrentExhibitions().then((list) => {
      if (active) setExhibitions(list);
    });

    return () => {
      active = false;
    };
  }, []);

  return (
    <GalleryScope>
      <div className="boxed_wrapper lg-gallery">
        <BannerHome />

        <ActivitySection />

        <IntroSection />

        <AuctionAndExhibition />

        <CurrentExhibitions exhibitions={exhibitions} />

        <Publication />

        <Video />

        <HowTosell />

        <GalleriesSection />

        <LiveStream />
      </div>
    </GalleryScope>
  );
}

export default Home;